<template>
  <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end>
                    <v-flex xs12>
                      <h1> Cadastro de Empresa </h1>
                      <v-spacer></v-spacer>
                    </v-flex>
                    </v-layout>

                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-stepper v-model="e1" alt-labels>
                          <v-stepper-header>
                            <v-stepper-step step="1" :complete="e1 > 1" editable>Empresa</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="e1 > 2">Responsável</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3">Submeter</v-stepper-step>
                          </v-stepper-header>
                          <v-stepper-items>
                            <v-stepper-content step="1">
                              <step1 @next="e1 = 2"
                              v-on:result="result"
                              @dados1="step1Atual"></step1>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                              <step2 @next="e1 = 3"
                              @prev="e1 = 1"
                              v-on:result="result"
                              :step1Data="step1Data"
                              @dados2="step2Atual"></step2>                              
                            </v-stepper-content>
                            <v-stepper-content step="3">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <h2>Deseja finalizar o cadastro?</h2>
                                  <br>
                                </v-flex>
                                  <v-flex xs6 justify-start>
                                    <h3 class="ml-4">Empresa </h3>
                                    <br>
                                    <p><strong>Nome: </strong>{{ step1Data.name }}</p>
                                    <br>
                                    <p><strong>Razão Social: </strong>{{ step1Data.razao_social }}</p>
                                    <br>
                                    <p v-if="step1Data.tipo === 'P'"><strong>Tipo: </strong>Proprietário</p>
                                    <p v-if="step1Data.tipo === 'M'"><strong>Tipo: </strong>MakerLab</p>
                                    <br>
                                    <p><strong>CNPJ: </strong>{{ step1Data.cnpj }}</p>
                                    <br>
                                    <p><strong>Número de Licenças: </strong>{{ step1Data.licencas }}</p>
                                    <br>
                                  </v-flex>
                                  <v-flex xs6 justify-start>
                                    <h3 class="ml-4">Responsável </h3>
                                    <br>
                                    <p><strong>Nome de usuário: </strong>{{ step2Data.username }}</p>
                                    <br>
                                    <p><strong>Nome: </strong>{{ step2Data.first_name }}</p>
                                    <br>
                                    <p><strong>Sobrenome: </strong>{{ step2Data.last_name }}</p>
                                    <br>
                                    <p><strong>E-mail: </strong>{{ step2Data.email }}</p>
                                    <br>
                                  </v-flex>
                                <v-btn color="primary"  @click.native="e1 = 2" >voltar</v-btn>
                                <v-btn color="primary"  @click.native="cadastrar" 
                                  :loading="animation">
                                  <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                                    <span v-else>
                                      Finalizar
                                    </span>
                                    </v-btn>

                              </v-layout>
                            </v-stepper-content>                        
                          </v-stepper-items>  
                        </v-stepper>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
import Step1 from './CadastroSteps/Step1.vue'
import Step2 from './CadastroSteps/Step2.vue'
export default {
  components: {
    Step1,
    Step2
  },
  data () {
    return {
      e1: 1,
      step1Data: [],
      step2Data: [],
      teste: ['teste1', '2'],
      loading: false,
      animation: false,
      result: {}
    }
  },
  methods: {
    step1Atual (result) {
      this.step1Data = result
      console.log(this.step1Data)
    },
    step2Atual (result) {
      this.step2Data = result
      console.log(this.step2Data)
    },
    cadastrar () {
      // this.animation = true
      // console.log(self.empresaData)
      api.request('POST', 'companies/', this.step1Data).then(response => {
        this.step2Data.company = response.data.id
        api.request('POST', 'create-user/', this.step2Data).then(resp => {
          var payload = {
            'responsavel': resp.data.id
          }
          api.request('PATCH', 'companies/' + this.step2Data.company + '/', payload).then(response => {
            if (response.data.id) {
              let name = '/empresas/' + response.data.id
              this.animation = false
              this.$router.push(name)
            } else {
              console.log(response)
              this.animation = false
            }
          })
        })
      }).catch(function (error) {
        console.log(error)
        self.animation = false
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Empresas/Cadastro.vue